module.exports = __webpack_public_path__ + "static/media/Close.9200862a.svg";